<template>
  <div class="container presentation-container">
    <div class="mb-4">
      <div class="w-100 px-5 py-2" style="background-color: #3281bc;">
        <img src="../../../public/assets/images/white-logo.png" alt="Logo">
      </div>
      <div class="d-flex justify-content-between align-items-center">
        <h4 class="strong mr-5">Real Estate Appraiser Errors & Omissions Premium Proposal</h4>
        <img src="../../../public/assets/images/call.png" class="img-call" alt="Logo">
      </div>
      <h4 class="strong mr-5" v-if="state.premium === 0">
        Please enter the “Total Premium Due” —then click “Pay in Full” to proceed.
      </h4>
    </div>
    <div class="d-flex my-5" v-if="state.premium === 0">

      <form action="https://www.asecurecart.net/server/cart.aspx/orepinsurance" target="_blank" method="POST" name="frm">
        <input name="TaxItem" type="hidden" value="n">
        <input name="AddEmail" type="hidden" value="appraisers@orep.org">
        <input name="ID" type="hidden" value="Premium" class="orep-label mb-0 ml-1">
        <input name="ID" type="hidden" value="OREP Fee">
        <div style="margin-bottom: 10px">
          <label for class="orep-label mb-0 ml-1">
            Premium:
          </label>
          <input  class="orep-text-input w-100" style="border: 1px solid #ccc;border-radius: 4px;box-sizing: border-box;" type="number" min="0.01" step="0.01" name="Price">
          <label for class="orep-label mb-0 ml-1">
            OREP FEE:
          </label>
          <input   class="orep-text-input w-100" name="Price"  :value="(orepfee()).toFixed(2)" readonly>
        </div>
        <input name="Multi" type="hidden" value="Y">
        <input class="btn btn-secondary btn-lg mr-5" name="Submit" type="submit" value="PAY IN FULL NOW">
      </form>
    </div>
    <div class="mb-4 coverage" v-if="state.premium !== 0" >
      <table class="table table-bordered">
        <tbody>
          <tr>
            <td>
              <strong>Limits of Coverage:</strong>
            </td>
            <td>
              <strong>{{coverage()}}</strong>
            </td>
          </tr>
          <tr>
            <td style="padding-bottom: 1rem !important;">
              <strong>Deductible:</strong>
            </td>
            <td style="padding-bottom: 1rem !important;">
              <strong>$0 (by OREP Membership endorsement)</strong>
            </td>
          </tr>
          <tr>
            <td>
              <strong>Premium:</strong>
            </td>
            <td>
              <strong>${{(state.premium).toFixed(2)}}</strong>
            </td>
          </tr>
          <tr>
            <td>OREP Member Fee:</td>
            <td>${{orepfee().toFixed(2)}}</td>
          </tr>
          <tr v-if="individualAppraiser.amcExtensionCoverage">
            <td>AMC Extension Coverage:</td>
            <td>${{(state.premium * 0.1).toFixed(2)}}</td>
          </tr>
          <tr v-if="individualAppraiser.traineeCoverage">
            <td>Trainee Coverage:</td>
            <td>${{(state.premium * 0.5).toFixed(2)}}</td>
          </tr>
          <tr>
            <td>
              <h5 class="font-weight-bold m-0">Total:</h5>
            </td>
            <td>
              <h5 class="font-weight-bold m-0">${{total().toFixed(2)}}</h5>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="d-flex my-5" v-if="state.premium !== 0">
      <form action="https://www.asecurecart.net/server/cart.aspx/orepinsurance" target="_blank" method="POST" name="frm">
        <input name="TaxItem" type="hidden" value="n">
        <input name="AddEmail" type="hidden" value="appraisers@orep.org">
        <input name="ID" type="hidden" value="Premium">
        <input name="ID" type="hidden" value="OREP Fee">
        <input name="Price" type="hidden" :value="(total()-50).toFixed(2)">
        <input name="Price" type="hidden" :value="(orepfee()).toFixed(2)">
        <input name="Multi" type="hidden" value="Y">
        <input class="btn btn-secondary btn-lg mr-5" name="Submit" type="submit" value="PAY IN FULL NOW">
      </form>
      <router-link
        :to="{name: 'individual-appraiser-request-financing', params: {id: individualAppraiser.id}}"
        class="btn btn-secondary btn-lg"
        target="_blank"
        v-if="individualAppraiser.customer.state === 'KY'"
      >
        REQUEST FINANCING
      </router-link>

      <a v-if="individualAppraiser.customer.state !== 'KY'"
         v-bind:href="'https://orep.org/financestratford50/index.php?name='+ individualAppraiser.businessNameOfAppraiser+'&ia_name='+individualAppraiser.fullLegalNameOfAppraiser+'&address='+encodeURIComponent(individualAppraiser.customer.address)+'&city='+individualAppraiser.customer.city+'&state_code='+individualAppraiser.customer.state+'&zip='+individualAppraiser.customer.zipCode+'&phone='+individualAppraiser.customer.phone+'&email='+individualAppraiser.customer.email+'&date='+getEffectiveDate()+'&premium='+(total()-50).toFixed(2)" class="btn btn-secondary btn-lg mr-5" target="_blank">REQUEST FINANCING</a>
    </div>
    <div class="col mt-1 small">
      <p class="input-info">
        <i class="fas fa-exclamation-triangle not-eligible"></i><span class="not-eligible-text">
                  If you are new to OREP, please email a copy of your Expiring Declarations Page to
                  <strong><a href="mailto:appraisers@orep.org" target="_top">appraisers@orep.org</a></strong>
                </span>
      </p>
    </div>

  <div class="mb-4 program-highlight">
    <p class="mt-4">
    </p>
      <h4>Program Highlights</h4>
      <ul>
        <li style="padding-bottom:1em">"A" Rated, Admitted Carrier (AM Best Rating)</li>
        <li style="padding-bottom:1em">$10,000 Disciplinary Proceedings Coverage</li>
        <li style="padding-bottom:1em">Broad Coverage for Appraisers: Coverage for Residential, Commercial, Right of Way Appraisals</li>
        <li style="padding-bottom:1em">Inexpensive Option to Add Trainee Coverage</li>
        <li style="padding-bottom:1em">$25,000 Subpoena Assistance</li>
        <li style="padding-bottom:1em">Loss of Earning: $500 a day, $10,000 maximum.</li>
        <li style="padding-bottom:1em">AMC Extension Coverage Available</li>
        <li style="padding-bottom:1em">FREE extended reporting period in case of disability/death</li>
        <li style="padding-bottom:1em">FREE extended reporting period upon retirement (if an OREP policyholder for 5 years)</li>
        <li>OREP Serving Appraiser’s E&O Insurance Needs over 20 Years</li>
      </ul>
      <p class="strong mt-4">Why OREP</p>
      <ul>
        <li style="padding-bottom:1em">14 Hours FREE CE for Appraisers (<a href="https://orep.org/list-approved-ce/" target="_blank">click for List of Approved States</a>)</li>
        <li style="padding-bottom:1em">Free State Board Complaint Consulting</li>
        <li style="padding-bottom:1em">Free Risk Management and Claims Support</li>
        <li style="padding-bottom:1em">Guaranteed Delivery of Working RE Magazine</li>
      </ul>
    </div>

    <div class="mb-4 footer">
      <div class="d-flex my-5"  v-if="state.premium !== 0">
        <form action="https://www.asecurecart.net/server/cart.aspx/orepinsurance" target="_blank" method="POST" name="frm">
          <input name="TaxItem" type="hidden" value="n">
          <input name="AddEmail" type="hidden" value="appraisers@orep.org">
          <input class="btn btn-secondary btn-lg mr-5" name="Submit" type="submit" value="PAY IN FULL NOW">
          <input name="ID" type="hidden" value="Premium">
          <input name="ID" type="hidden" value="OREP Fee">
          <input name="Price" type="hidden" :value="(total()-50).toFixed(2)">
          <input name="Price" type="hidden" :value="(orepfee()).toFixed(2)">
          <input name="Multi" type="hidden" value="Y">
        </form>
        <router-link
          :to="{name: 'individual-appraiser-request-financing', params: {id: individualAppraiser.id}}"
          class="btn btn-secondary btn-lg"
          target="_blank"
          v-if="individualAppraiser.customer.state === 'KY'"
        >
          REQUEST FINANCING
        </router-link>

        <a v-if="individualAppraiser.customer.state !== 'KY'"
           v-bind:href="'https://orep.org/financestratford50/index.php?name='+ individualAppraiser.businessNameOfAppraiser+'&ia_name='+individualAppraiser.fullLegalNameOfAppraiser+'&address='+encodeURIComponent(individualAppraiser.customer.address)+'&city='+individualAppraiser.customer.city+'&state_code='+individualAppraiser.customer.state+'&zip='+individualAppraiser.customer.zipCode+'&phone='+individualAppraiser.customer.phone+'&email='+individualAppraiser.customer.email+'&date='+getEffectiveDate()+'&premium='+(total-50).toFixed(2)" class="btn btn-secondary btn-lg mr-5" target="_blank">REQUEST FINANCING</a>
      </div>
      <p class="mt-3 strong">OREP</p>
      <p>6353 El Cajon Blvd, Suite 124-605</p>
      <p>San Diego, CA 92115 </p>
      <p>(888) 347-5273</p>
      <p>inspectors@OREP.org</p>
      <p>OREP Insurance Services, LLC. Calif. Lic. #0K99465</p>
    </div>
  </div>
</template>

<script>
  import $ from "jquery";
  import moment from "moment";
  export default {

    name: "individual-appraiser-representation",
    computed: {

      individualAppraiser() {
        return this.$store.state.individualAppraiser.individualAppraiser;
      },
      state() {
        return this.$store.state.individualAppraiser;
      },
      errorMsg() {
        return this.$store.state.individualAppraiser.errorMsg;
      },
    },
    created: function(){
      if (this.state.premium == 0){
        window.location.href = "https://orep.org/appraiser-portal-payment/"
        // this.$router.push('https://orep.org/appraiser-portal-payment/')
      }
    },
    methods: {
      getEffectiveDate() {
        return moment.utc(this.state.individualAppraiser.effectiveDate).format('MM/DD/YYYY');
      },
      total() {
        if (this.state.premium !== 0) {
          let total = this.state.premium + 50;
          // if (this.individualAppraiser.customer.state === 'CO' || this.individualAppraiser.customer.state === 'FL') {
          if (this.individualAppraiser.customer.state === 'CO') {
            total = this.state.premium + 50;
          }

          if (this.individualAppraiser.amcExtensionCoverage) {
            total += this.state.premium * 0.1;
          }
          if (this.individualAppraiser.traineeCoverage) {
            total += this.state.premium * 0.5;
          }

          return total;
        }
        else {
          return 0;
        }
      },
      coverage() {
        switch (this.individualAppraiser.limitOfCoverage) {
          case '0.3M/0.6M':
            return '$300,000 / $600,000';
          case '0.5M/1M':
            return '$500,000 / $1,000,000';
          case '1M/1M':
            return '$1,000,000 / $1,000,000';
          default:
            return '$1,000,000 / $2,000,000';
        }
      },
      orepfee() {
        // if (this.individualAppraiser.customer.state === 'CO' || this.individualAppraiser.customer.state === 'FL') {
        if (this.individualAppraiser.customer.state === 'CO') {
          return 50;
        }
        else {
          if (this.state.premium !== 0) {
            return 50;
          }
          else {
            return 50;
          }
        }
      },
    },

    mounted() {
      $('html, body').animate({
          scrollTop: $('.presentation-container').offset().top
      }, 500);
    },
  }
</script>

<style scoped>
  .container {
    background-color: white !important;
    padding-bottom: 30px;
  }
  .img-call {
    height: 170px;
    max-height: 170px;
  }
  p {
    margin: 5px 0;
  }
  .strong {
      font-weight: bold !important;
  }
  table td {
    padding: 0 5px !important;
  }
  table > tbody > tr > td:first-child {
    width: 35%
  }
  table > tbody > tr > td:last-child {
    width: 65%
  }


  .table-bordered td {
    vertical-align: top;
    border-right: 2px solid #dee2e6;
    border-left-width: 0;
    border-bottom-width: 0;
    border-top-width: 0;
  }
</style>
